import styled from 'styled-components';
import InfoCard from '/components/ui/newCards/InfoCard';
import EnovaIcon from '/components/icons/EnovaIcon';
import Paragraph from '../ui/typography/Paragraph';
import { formatPrice } from '/lib/helpers';
import Link from 'next/link';
import { colors } from '/css';
import { HTMLAttributes } from 'react';
import { LineItem } from '/types/lineItemTypes';
import useEnova from '/hooks/useEnova';
import { Amount } from '/types/moneyType';

interface Props extends HTMLAttributes<HTMLDivElement> {
    lineItems: LineItem[];
    total: Amount;
}

export default function EnovaCashbackSummary({
    lineItems,
    total,
    ...rest
}: Props) {
    const { enovaJobs, enovaCashbackAmount } = useEnova(lineItems);

    if (!total || enovaJobs.length === 0 || !enovaCashbackAmount) return null;

    const totalAfterCashback = total.gross - enovaCashbackAmount;

    return (
        <StyledInfoCard variant="green" {...rest}>
            <Paragraph size="smaller" className="flex align-center mb-8-all">
                <EnovaIcon />
                Enovastøtte
            </Paragraph>
            <Paragraph size="smaller">
                Du kan få <strong>{formatPrice(enovaCashbackAmount)}</strong>{' '}
                refundert av Enova. Reel kostnad etter støtte{' '}
                <strong>{formatPrice(totalAfterCashback)}</strong>. <br />
                <Link href="/enova">Les mer</Link>
            </Paragraph>
        </StyledInfoCard>
    );
}

const StyledInfoCard = styled(InfoCard)`
    svg {
        width: 15px;
        height: 15px;
        margin-right: 8px;
    }
    strong {
        font-family: 'gellix-bold';
    }
    a {
        color: ${colors.black}!important;
        text-decoration: underline;
        @media (pointer: fine) {
            &:hover {
                color: ${colors.purple}!important;
            }
        }
    }
`;
